module.exports = __webpack_public_path__ + "static/media/eye.7ff1b6dd.svg";